import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { CheckIcon } from 'secondstep-components'

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const CircleIcon = styled.div.attrs(({ isActive, isCompleted }) => ({
  background: isCompleted
    ? themeGet('colors.k5kit4')
    : isActive
    ? themeGet('colors.k5kit7')
    : 'none',
  borderColor:
    isCompleted || isActive
      ? themeGet('colors.k5kit4')
      : themeGet('colors.blueGrayLight'),
}))`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 12px;
  height: 12px;
  border: 2px solid ${({ borderColor }) => borderColor};
  border-radius: 50%;
  background: ${({ background }) => background};
`

export const StyledButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  position: relative;
`

export const StyledCheckIcon = styled(CheckIcon)`
  width: 10px;
  height: 10px;
  color: ${themeGet('colors.white')} !important;
`

export const Text = styled.span.attrs(({ isActive }) => ({
  color: isActive ? themeGet('colors.darkBlue') : themeGet('colors.darkGray'),
  fontFamily: isActive
    ? themeGet('font.molde.medium')
    : themeGet('font.molde.regular'),
}))`
  width: 112px;
  padding: 0.375rem 0.75rem;
  background: ${themeGet('colors.paleGray')};
  color: ${({ color }) => color};
  font-size: 0.875rem;
  font-family: ${({ fontFamily }) => fontFamily};
  border-radius: 0.625rem;
  position: absolute;
  top: 28px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;

  &::before {
    content: '';
    position: absolute;
    top: -8px;
    left: 50%;
    transform: translateX(-50%);
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid ${themeGet('colors.paleGray')};
    width: 0;
    height: 0;
  }
`
